import { SearchBox as SearchBoxBase } from "@omni/components/components/Search/SearchBar/components/SearchBox/searchBox";

import { SearchBoxComponent } from "@/components/Search/SearchBar/components/SearchBox/searchBox.component";

export const SearchBox = () => {
    return (
        <SearchBoxBase>
            <SearchBoxComponent />
        </SearchBoxBase>
    );
};
